// extracted by mini-css-extract-plugin
export default {"error-page__container":"ErrorPage_error-page__container__-eeJG","wrapper":"ErrorPage_wrapper__B2Uxg","landing-page":"ErrorPage_landing-page__A-lDz"};